import { call, delay, put, takeLatest } from 'redux-saga/effects';
import { checkSign } from '../../../Taps/services';
import { actionTypes, requestFailure, requestSuccess } from './actions';

function* getStatus() {
  const response = yield call(checkSign);
  yield put(response.isOk ? requestSuccess(response.data) : requestFailure(response.error));
  if (response.isOk) {
    const { registrationStatus } = response.data;
    if (registrationStatus === 'inProcess') {
      yield delay(15000);
      yield call(getStatus);
    }
  }
}

export default function* checkRegistrationStatus() {
  yield takeLatest(actionTypes.REQUEST_START, getStatus);
}
